// eslint-disable-next-line
import {
  getSensors,
  getRssiRanges,
} from '@/api/index';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state() {
    return ({
      sensor: {},
      sensors: [],
      rssiIcon: null,
      rssiRanges: [],
      showAlertList: true,
      ringsData: null
    });
  },
  getters: {
    /* = Computed properties, perfects to filter data an execute some calculation */
  },
  mutations: {
    async cleanSensor(state) {
      state.sensor = {};
    },

    async setSensor(state, payload) {
      state.sensor = {
        ...state.sensor,
        ...payload
      };
      const iconRssi = Mixin.methods.G_getRssiIcon(state.sensor, state.rssiRanges);
      // eslint-disable-next-line
      state.rssiIcon = await require(`@/assets/img/sensor/${iconRssi}`);
    },
    setSensors(state, payload) {
      state.sensors = payload;
    },
    setRssiRanges(state, rssiRanges) {
      state.rssiRanges = rssiRanges;
    },
    updateSensor(state, cleanSensor){
      let tempIndex = state.sensors.findIndex( sensor => state.sensor.sensor_id === sensor.sensor_id );
      state.sensors[tempIndex] = { ...state.sensors[tempIndex], ...cleanSensor };
    },

    setShowAlertList(state, showAlertList){
      state.showAlertList = showAlertList;
    },

    setRingData(state, ringsData){
      state.ringsData = ringsData;
    }
  },
  actions: {
    async apiGetSensors(context) {
      if (Mixin.methods.G_isEmptyArr(context.state.rssiRanges)) {
        await getRssiRanges().then((rssiRanges) => {
          context.commit('setRssiRanges', rssiRanges);
        });
      }
      await getSensors(null).then((res) => {
        context.commit('setSensors', res.sensors);
      });
    },

    cleanUp(context) {
      let cleanSensor = {
        status: {
          i18n: "sensors.statusDeployPending",
          name: "Inventory",
          status_id: Mixin.data().consts.SensorStatus.DEPLOY_PENDING,
        },
        status_id: Mixin.data().consts.SensorStatus.DEPLOY_PENDING,
        latitude: null,
        longitude: null,
        provision_date: null,
        last_reading: null,
        rssi: null,
        prongs_depth: null,
        sensor_depth: null,
        location_desc: null,
        location_code: null,
        hole: null,
      }

      context.commit('setSensor', cleanSensor);
      context.commit('updateSensor', cleanSensor);
    },

    async apiLoadRssiRanges(context) {
      if (Mixin.methods.G_isEmptyArr(context.state.rssiRanges)) {
        await getRssiRanges().then((rssiRanges) => {
          context.commit('setRssiRanges', rssiRanges);
        });
      }
    },

  },
};
